<template lang="pug">
div.wrap-asset-searcher.w-full.h-full
  div.asset-searcher-content.relative.pt12
    div.wrap-search
      v-text-field(v-model="keyword"
        @keyup.enter="search" @keydown.stop
        prepend-inner-icon="mdi-magnify"
        placeholder="キーワードで検索" autofocus outlined)
      div.wrap-type-selector.f.flex-wrap.mb4
        div(v-for="item in assetTypes"
          @click="onAssetType(item.type)").f.fm.mr12.mb8.cursor-pointer
          v-icon(:color="(selectedTypes.includes(item.type)) ? pallete.$active_color : pallete.$secondary_text_color").mr4 {{item.icon}}
          span(:style="`color: ${(selectedTypes.includes(item.type)) ? pallete.$active_color : pallete.$secondary_text_color};`") {{item.name}}

    div(ref="wrapAssets" v-if="!isLoading"
      ).wrap-result.relative.f.flex-between.flex-wrap.pb100.overflow-scroll
      ItemAssetCardToAdd(v-for="asset in showingResultAssets" :key="asset.id"
        :asset="asset" :user="user"
        :assetIdsToAdd="assetIdsToAdd" :selfRatings="selfRatings"
        @addSelectedAsset="addSelectedAsset" @onTag="onTag")
      div(v-if="!showingResultAssets[0]").f.fh.w-full.h-full.pb100
        div
          span.block.text-center.c-secondary.mb50 {{noResultText}}
          div(v-if="['actor'].includes(selectedTypes[0])")
            span.block.text-center.fz14.mb4
              | #[a(href="https://vroid.com/studio" target="_blank") Vroid Studio]
              | でオリジナルの俳優を作成したり、
            span.block.text-center.fz14.mb4
              | #[a(href="https://hub.vroid.com" target="_blank") Vroid Hub]
              | で利用可能なキャラクターモデルを探してみましょう！
            span.block.text-center.fz14 作成、もしくはダウンロードしたモデルをComicaroidに
              | #[a(@click="$emit('toUploadTab')") アップロード]できます。
          div(v-if="['3d_object', '3d_stage'].includes(selectedTypes[0])")
            span.block.text-center.fz14.mb4
              | #[a(href="https://sketchfab.com/3d-models/popular" target="_blank") Sketchfab]
              | の3Dモデルをダウンロードして利用してみましょう！
            span.block.text-center.fz14.mb4
              | #[a(href="https://app.mirageml.com/showcase" target="_blank") Mirage]
              | を使うと検索の他にテキストから3Dモデルを生成することもできます。
            span.block.text-center.fz14 ダウンロード、もしくは生成したモデルをComicaroidに
              | #[a(@click="$emit('toUploadTab')") アップロード]してみましょう！
          div(v-if="['effect_background'].includes(selectedTypes[0])")
            span.block.text-center.fz14.mb4
              | #[a(href="https://mangasozai.com" target="_blank") 漫画パーツSTOCK]
              | などで利用可能な素材を検索してみましょう！
            span.block.text-center.fz14 ダウンロードしたフリー素材をComicaroidに
              | #[a(@click="$emit('toUploadTab')") アップロード]にできます。
          div(v-if="['onomatopoeia'].includes(selectedTypes[0])")
            span.block.text-center.fz14.mb4
              | #[a(href="https://dddfont.com/" target="_blank") 漫画文字素材 ドドドFonts]
              | などで利用可能な素材を検索してみましょう！
            span.block.text-center.fz14 ダウンロードしたフリー素材をComicaroidに
              | #[a(@click="$emit('toUploadTab')") アップロード]にできます。
          div(v-if="['background', 'image_object'].includes(selectedTypes[0])")
            span.block.text-center.fz14.mb4
              | #[a(href="https://aisozai.com/" target="_blank") AI素材.com]、
              | #[a(href="https://unsplash.com/" target="_blank") Unsplash]
              | などで利用可能素材を探すこともできます。
            span.block.text-center.fz14.mb4 ダウンロードしたフリー素材をComicaroidに
              | #[a(@click="$emit('toUploadTab')") アップロード]にして利用してみましょう！
            span.block.text-center.fz14 
              | #[a(@click="$emit('toUploadTab')") アップロード]した画像は漫画風に画風変換できます。

    div(v-else).wrap-loading.f.fh
      v-progress-circular(:color="pallete.$active_color" indeterminate)
    //- div(v-if="assetIdsToAdd[0]"
    //-   @click="onAdd").btn-add.absolute.w-full.f.fh.py12.cursor-pointer
    //-   span {{assetIdsToAdd.length}}件のアセットを追加
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-asset-searcher {
  .asset-searcher-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    .wrap-search {
      .btn-search {
        color: $dark_primary_text_color;
        background: $active_color;
        border-radius: 3px;
      }
    }
    .wrap-result, .wrap-loading {
      height: calc(#{$device_height} - 200px);
    }
    .wrap-result {
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {  /* Chrome, Safari 対応 */
        display:none;
      }
    }
    .wrap-loading {
      min-height: 300px;
    }
  }
  .btn-add {
    bottom: 70px;
    border-radius: 3px;
    box-shadow: $box_shadow;
    background: $active_color;
    z-index: 1;
    color: $dark_primary_text_color;
  }
}
</style>

<style lang="scss">
.wrap-asset-searcher {
  .v-text-field__details {
    display: none;
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import ItemAssetCardToAdd from '@/components/item/studio/ItemAssetCardToAdd'

export default {
  components: {
    ItemAssetCardToAdd
  },
  props: {
    assetType: {
      type: Object,
      default: null
    },
    assetIdsToAdd: {
      type: Array,
      required: true
    },
    selfRatings: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    frame: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    showingResultAssets () {
      return this.resultAssets.filter(r => {
        return !this.assetIdsExisting.includes(r.id)
      })
    },
    // noResultText () {
    //   let selectedAssetsLabel = this.assetTypes
    //     .filter(a => this.selectedTypes.includes(a.type))
    //     .map(a => a.name)
    //     .join('、')
    //   if (selectedAssetsLabel === '') {
    //     return `「${this.keyword}」に一致するアセットは見つかりませんでした。`
    //   } else {
    //     return `「${this.keyword}」に一致する「${selectedAssetsLabel}」のアセットは見つかりませんでした。`
    //   }
    // }
  },
  watch: {
    selectedTypes () {
      this.loadMoreAssets = true
      this.isLoadingByScroll = false
      this.oldestSecondsOfAsset = new Date().getTime() / 1000
      this.oldestImportedNumOfAsset = 10000000 * 10000000
      this.search()
    }
  },
  data () {
    return {
      keyword: '', resultText: '', noResultText: '',
      selectedTypes: [],
      resultAssets: [],
      assetIdsExisting: [],
      isLoading: false, isLoadingByScroll: false,
      loadLimit: 20,
      oldestSecondsOfAsset: new Date().getTime() / 1000,
      oldestImportedNumOfAsset: 10000000 * 10000000,
      loadMoreAssets: true
    }
  },
  async created () {
    if (this.assetType) this.selectedTypes.push(this.assetType.type)
    // this.isLoading = true
    // this.search()
    // this.resultAssets = await database.assetCollection()
    //   .searchAssetsByKeyword({ 
    //     keyword: this.keyword,
    //     types: this.selectedTypes
    //   })
    // this.isLoading = false

    // const rp = this.$route.params
    // this.frame = await database
    //   .frameCollection(rp.comicId, rp.episodeId, rp.pageId)
    //   .findById(rp.frameId)
    const types = this.assetTypes.map(e => e.type)
    this.assetIdsExisting = types
      .map(t => this.frame.assetOrder[t] ? this.frame.assetOrder[t] : []).flat()
  },
  mounted () {
    this.$refs.wrapAssets.addEventListener('scroll', this.onScroll)
  },
  beforeUnmount () {
    this.$refs.wrapAssets.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    async search () {
      if (this.isLoading) return
      this.isLoading = true
      this.loadMoreAssets = true
      this.oldestSecondsOfAsset = new Date().getTime() / 1000
      this.oldestImportedNumOfAsset = 10000000 * 10000000
      let searchParams = {
        keyword: this.keyword,
        types: this.selectedTypes,
        uid: this.uid,
        seconds: this.oldestSecondsOfAsset,
        importedNum: this.oldestImportedNumOfAsset,
        limit: this.loadLimit
      }
      
      this.resultAssets = await database.assetCollection()
        .searchAssetsByKeyword(searchParams)
      if (this.resultAssets[0]) {
        const lastAsset = this.resultAssets[this.resultAssets.length - 1]
        if (this.oldestImportedNumOfAsset === lastAsset.importedNum) {
          this.oldestSecondsOfAsset = lastAsset.createdAt._seconds
        } else {
          this.oldestSecondsOfAsset = new Date().getTime() / 1000
        }
        this.oldestImportedNumOfAsset = lastAsset.importedNum
      }
      // if (this.resultAssets[0]) {
      //   this.oldestSecondsOfAsset = this.resultAssets[this.resultAssets.length - 1].createdAt._seconds
      //   this.oldestImportedNumOfAsset = this.resultAssets[this.resultAssets.length - 1].importedNum
      // } else {
      //   this.loadMoreAssets = false
      // }

      this.isLoading = false
      this.$nextTick(() => {
        this.$refs.wrapAssets.scrollTop = 0
      })

      if (!this.showingResultAssets[0]) {
        let selectedAssetsLabel = this.assetTypes
          .filter(a => this.selectedTypes.includes(a.type))
          .map(a => a.name)
          .join('、')
        if (selectedAssetsLabel === '') {
          this.noResultText = `「${this.keyword}」に一致するアセットは見つかりませんでした。`
        } else {
          this.noResultText = `「${this.keyword}」に一致する「${selectedAssetsLabel}」のアセットは見つかりませんでした。`
        }
      }

      if (this.keyword !== '') {
        this.sendMixpanelEvent({
          msg: 'searchAssetByKeyword',
          info: {
            keyword: this.keyword,
            types: this.selectedTypes,
            resultAssets: this.resultAssets,
            resultNum: this.resultAssets.length,
            loadLimit: this.loadLimit
          }
        })
      }
    },
    async onTag (tag) {
      if (this.isLoading) return
      this.isLoading = true

      this.loadMoreAssets = true

      this.keyword = tag
      this.oldestSecondsOfAsset = new Date().getTime() / 1000
      this.oldestImportedNumOfAsset = 10000000 * 10000000
      let searchParams = {
        keyword: this.keyword,
        types: this.selectedTypes,
        uid: this.uid,
        seconds: this.oldestSecondsOfAsset,
        importedNum: this.oldestImportedNumOfAsset,
        limit: this.loadLimit
      }
      this.resultAssets = await database.assetCollection()
        .searchAssetsByKeyword(searchParams)
      if (this.resultAssets[0]) {
        this.oldestSecondsOfAsset = this.resultAssets[this.resultAssets.length - 1].createdAt._seconds
        this.oldestImportedNumOfAsset = this.resultAssets[this.resultAssets.length - 1].importedNum
      } else {
        this.loadMoreAssets = false
      }

      this.isLoading = false
      this.$nextTick(() => {
        this.$refs.wrapAssets.scrollTop = 0
      })

      this.sendMixpanelEvent({
        msg: 'searchAssetByTag',
        info: {
          keyword: this.keyword,
          types: this.selectedTypes,
          resultAssets: this.resultAssets,
          resultNum: this.resultAssets.length,
          loadLimit: this.loadLimit
        }
      })
    },
    onAssetType (type) {
      if (this.selectedTypes.includes(type)) {
        this.selectedTypes = this.selectedTypes.filter(s => s !== type)
      } else {
        this.selectedTypes.push(type)
      }
    },
    onScroll () {
      const wrapAssets = this.$refs.wrapAssets
      if ((wrapAssets.scrollHeight - wrapAssets.clientHeight) <=  wrapAssets.scrollTop + 4) {
        this.loadAssets()
      }
    },
    async loadAssets () {
      if (!this.loadMoreAssets || this.isLoadingByScroll) return
      this.isLoadingByScroll = true
      let newAssets = await database.assetCollection()
        .searchAssetsByKeyword({ 
          keyword: this.keyword,
          types: this.selectedTypes,
          uid: this.uid,
          seconds: this.oldestSecondsOfAsset,
          importedNum: this.oldestImportedNumOfAsset,
          limit: this.loadLimit
        })
      
      // TODO: そもそもクエリを最適化して重複したアセットをロードしないような仕様にしたい
      const existingAssetIds = this.resultAssets.map(a => a.id)
      newAssets = newAssets.filter(n => !existingAssetIds.includes(n.id))

      if (newAssets[0]) {
        this.resultAssets = this.resultAssets.concat(newAssets)
        if (this.resultAssets[0]) {
          const lastAsset = this.resultAssets[this.resultAssets.length - 1]
          if (this.oldestImportedNumOfAsset === lastAsset.importedNum) {
            this.oldestSecondsOfAsset = lastAsset.createdAt._seconds
          } else {
            this.oldestSecondsOfAsset = new Date().getTime() / 1000
          }
          this.oldestImportedNumOfAsset = lastAsset.importedNum
        }
        // if (newAssets.length < this.loadLimit) this.loadMoreAssets = false
        this.isLoadingByScroll = false
      } else {
        this.loadMoreAssets = false
      }
    },
    addSelectedAsset (assetId) {
      this.$emit('addSelectedAsset', assetId)
    }
  }
}
</script>
